import React from 'react';

const aplicaciones = [
    {
        id: 'oficinas',
        titulo: 'Oficinas y espacios comerciales',
        descripcion: 'Suma un punto focal verde en recepciones, salas de juntas y locales, sin plantas que cuidar.',
        imagen: 'aplicacion-oficinas.jpg'
    },
    {
        id: 'restaurantes',
        titulo: 'Restaurantes y cafeterías',
        descripcion: 'Ambienta terrazas y muros interiores sin preocuparte por el riego diario ni el desgaste por manipulación.',
        imagen: 'aplicacion-restaurantes.jpg'
    },
    {
        id: 'fachadas',
        titulo: 'Fachadas y exteriores',
        descripcion: 'Los modelos HDPE con filtro UV están pensados para resistir sol y lluvia sin perder el color.',
        imagen: 'aplicacion-fachadas.jpg'
    },
    {
        id: 'terrazas',
        titulo: 'Terrazas y roof gardens',
        descripcion: 'Cubre muros perimetrales o jardineras verticales sin mantenimiento posterior.',
        imagen: 'aplicacion-terrazas.jpg'
    }
];

// Un ícono distinto por caso de uso (SVG propio, sin depender de una fuente externa)
const iconos = {
    oficinas: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="3" width="14" height="18" rx="1" />
            <path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01" />
            <path d="M10 21v-4h4v4" />
        </svg>
    ),
    restaurantes: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 3v6a3 3 0 0 0 3 3v9" />
            <path d="M6 3v6M9 3v6" />
            <path d="M17 3c-1.5 0-2.5 1.3-2.5 3.5S16 11 17 11v10" />
        </svg>
    ),
    fachadas: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="17.5" cy="6.5" r="2.2" />
            <path d="M17.5 2.3v1M17.5 9.7v1M21.2 6.5h-1M14.8 6.5h-1M20 4.3l-.7.7M15.7 8.3l-.7.7" />
            <path d="M3 21V9l6-4 6 4v12" />
            <path d="M8 21v-6h2v6" />
        </svg>
    ),
    terrazas: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3c2 2.5 3 4.5 3 6.2A3 3 0 0 1 9 9.2C9 7.5 10 5.5 12 3z" />
            <path d="M12 12v9" />
            <path d="M7 21h10" />
            <path d="M8.5 12c-1.5 1-2.3 2.3-2.3 3.7A2.3 2.3 0 0 0 8.5 18M15.5 12c1.5 1 2.3 2.3 2.3 3.7A2.3 2.3 0 0 1 15.5 18" />
        </svg>
    )
};

const AplicacionesFollaje = () => {
    return (
        <section className="bg-light">
            <div className="container">
                <div className="row justify-content-center mb-2-3">
                    <div className="col-lg-8 text-center">
                        <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">
                            Aplicaciones versátiles
                        </span>
                        <div className="title-style2 mb-0">
                            <h2 className="h1">¿Dónde se usa el follaje artificial?</h2>
                        </div>
                    </div>
                </div>

                <div className="row mt-n1-9">
                    {aplicaciones.map((item, index) => (
                        <div key={item.id} className="col-md-6 mt-1-9">
                            <div className="card border-0 shadow-sm h-100 overflow-hidden wow fadeIn" data-wow-delay={`${(index + 1) * 100}ms`}>
                                {/* Contenedor de imagen a proporción fija: nunca se desborda, sin importar el tamaño real del archivo */}
                                <div className="position-relative" style={{ aspectRatio: '16 / 9', overflow: 'hidden', backgroundColor: '#eef1ee' }}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/img/productos/follaje-artificial/aplicaciones/${item.imagen}`}
                                        alt={item.titulo}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                    <span
                                        className="position-absolute bg-white text-primary d-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                        style={{ width: '38px', height: '38px', top: '14px', left: '14px' }}
                                    >
                                        {iconos[item.id]}
                                    </span>
                                </div>

                                <div className="p-1-6 p-lg-1-9">
                                    <h3 className="h5 mb-2">{item.titulo}</h3>
                                    <p className="mb-0 text-sm text-muted">{item.descripcion}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                
            </div>
        </section>
    );
};

export default AplicacionesFollaje;